var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 9.66667V13M8.00016 9.66667L12.0002 13M8.00016 9.66667L4.00016 13M14.0002 1V6.46667C14.0002 7.58677 14.0002 8.14682 13.7822 8.57465C13.5904 8.95097 13.2845 9.25693 12.9081 9.44868C12.4803 9.66667 11.9203 9.66667 10.8002 9.66667H5.20016C4.08006 9.66667 3.52001 9.66667 3.09218 9.44868C2.71586 9.25693 2.4099 8.95097 2.21815 8.57465C2.00016 8.14682 2.00016 7.58677 2.00016 6.46667V1M5.3335 5V7M8.00016 3.66667V7M10.6668 6.33333V7M14.6668 1H1.3335",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomView);
export default __webpack_public_path__ + "static/media/custom-view.9f57c83aeadea17fff35c25fef5d96f6.svg";
export { ForwardRef as ReactComponent };